/**
 *
 *  SuccessDialog
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 02/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import { useHistory } from "react-router-dom";

// Components
import Button from "../../Button/Button";

// Images
import partyPopperIcon from "../../../images/party-popper-icon.png";
import partyPopperIcon2x from "../../../images/party-popper-icon@2x.png";

export default function SuccessDialog() {
  const history = useHistory();

  const handleCtaClick = React.useCallback(() => {
    history.replace("/partners");
  });

  return (
    <>
      <div className="tbk-text-title-bold tbk-mb-1 tbk-text-blue-dark">
        Account created
      </div>
      <p className="tbk-text-main tbk-mb-4 tbk-text-blue-dark">
        Welcome to TruBe!
      </p>
      <div className="tbk-my-4 tbk-flex tbk-justify-center">
        <img
          src={partyPopperIcon}
          srcSet={`${partyPopperIcon2x} 1x, ${partyPopperIcon2x} 2x`}
          alt="Party Popper"
          width="106"
          height="100"
        />
      </div>

      <Button className="tbk-mb-3 tbk-w-full" onClick={handleCtaClick}>
        Let's go
      </Button>
    </>
  );
}
